import { UnionValueMap } from '../types/union-map';

type TraceparentVersionName = 'Version00';

export type TraceparentVersion = '00';

export const TraceparentVersion: UnionValueMap<TraceparentVersionName, TraceparentVersion> = {
    Version00: '00',
};
